export default __webpack_public_path__ + "static/media/imageUpload.6cd7b599.svg";